import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Drawer, Table, Popover, Divider, Modal, Button } from 'antd';
import { isMobile } from 'react-device-detect';
import { isValidDate } from '@/utils/helpers';
import { DeleteOutlined, DownOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import NumberFormat from 'react-number-format';
import { checkPermission } from '@/utils/permission';
import { removeAdditionalCost, getSpecificAdditionalCost } from '@/redux/actions/AdditionalCost';
import ExpandableText from '@/components/ExpandableText';
import AdditionalCostForm from './AdditionalCostForm';

const { confirm } = Modal;

class AdditionalCost extends Component {
    constructor() {
        super();
        this.state = {
            isOpenForm: false,
            currentItem: null
        };
    }

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({ isOpenForm: isOpenForm, currentItem: currentItem });
    }

    onEdit(id) {
        this.props.getSpecificAdditionalCost(id).then(res => {
            this.toggleOpenForm(true, res);
        })
    }

    onRemove(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeAdditionalCost(id).then(() => {
                this.reloadData();
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    onClose() {
        this.props.onCancel();
    }

    reloadData() {
        this.props.reloadAdditionalCost();
        this.props.reloadCustomer();
    }

    render() {
        const { isOpenForm, currentItem } = this.state;
        var { visible, data, customer_id } = this.props;

        const columns = [
            {
                title: '#',
                width: '80px',
                align: 'center',
                render: (text, record) => (
                    <div>
                        {
                            checkPermission('additional_cost', 'update') ? (
                                <>
                                    <EditOutlined className='color-primary' style={{ cursor: 'pointer' }} onClick={() => this.onEdit(record.id)} />
                                    <Divider type='vertical' />
                                </>
                            ) : null
                        }
                        {
                            checkPermission('additional_cost', 'remove') ? (
                                <DeleteOutlined style={{ color: 'red', cursor: 'pointer' }} onClick={() => this.onRemove([record.id])} />
                            ) : null
                        }
                    </div>
                )
            },
            {
                title: 'Tên',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => {
                    return (<>{text}</>)
                }
            },
            {
                title: 'Dịch vụ áp dụng',
                dataIndex: 'cost_service',
                key: 'cost_service',
                width: '150px',
                render: (_, record) => {
                    const services = record?.cost_service;
                    if (!services?.length) return (<div style={{ color: '#0a4e8f' }}>Tất cả</div>);

                    const content = services.map((item, index) => (
                        <div key={index} style={{ padding: '5px 0' }}>
                            {item.customer_service?.service?.name}
                        </div>
                    ));

                    return (
                        <div className='item-action-btn'>
                            <Popover placement="right" content={content}>
                                {services[0]?.customer_service?.service?.name} <DownOutlined />
                            </Popover>
                        </div>
                    );
                }
            },
            {
                title: 'Số tiền',
                dataIndex: 'amount',
                key: 'amount',
                width: '120px',
                render: (text, record) => {
                    return (
                        <div>
                            <NumberFormat value={text} displayType={'text'} suffix="đ" thousandSeparator={true} />
                        </div>
                    )
                }
            },
            {
                title: 'Ghi chú',
                dataIndex: 'note',
                key: 'note',
                width: '200px',
                render: (text, record) => {
                    return (
                        <ExpandableText text={text} rows={1} />
                    )
                }
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                width: '150px',
                render: (text, record) => {
                    return (
                        <>
                            {isValidDate(text, true)}
                        </>
                    )
                }
            },
            {
                title: 'Người tạo',
                dataIndex: 'created_user',
                key: 'created_user',
                width: '200px',
                render: (text, record) => {
                    return (
                        <>{record?.created_user?.full_name} </>
                    )
                }
            },
        ];

        return (
            <>
                <Drawer
                    visible={visible}
                    title="Chi phí bổ sung"
                    onOk={(e) => this.submit(e)}
                    onClose={() => this.onClose()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '75%'}
                >
                    {visible ?
                        <div>
                            <Button
                                type='primary'
                                icon={<PlusOutlined />}
                                onClick={() => this.toggleOpenForm(true)}
                                className='mb-2'
                                disabled={!checkPermission('additional_cost', 'add')}
                            >Thêm mới</Button>
                            <Table
                                size='small'
                                rowKey='key'
                                tableLayout="auto"
                                columns={columns}
                                dataSource={data || []}
                                pagination={false}
                                scroll={{
                                    x: 'max-content'
                                }}
                                className='mb-4 w-100'
                                locale={{ emptyText: "Chưa có dữ liệu" }}
                            />
                        </div>
                        : null}
                </Drawer>

                <AdditionalCostForm
                    visible={isOpenForm}
                    customer_id={customer_id}
                    data={data}
                    onCancel={() => this.toggleOpenForm(false)}
                    currentItem={currentItem}
                    reloadData={() => this.reloadData()}
                />
            </>
        )
    }
}

function mapStateToProps(state) {
    return {

    }
}

function mapDispatchToProps(dispatch) {
    return {
        removeAdditionalCost: (ids) => dispatch(removeAdditionalCost(ids)),
        getSpecificAdditionalCost: (id) => dispatch(getSpecificAdditionalCost(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalCost);
